/**
 * Lectura y validación de la configuración del entorno.
 *
 * No se lanza una excepción al importar este archivo, aunque sería lo más
 * corto: eso deja la página en blanco y obliga a abrir la consola para saber
 * qué pasó. En vez de eso se reporta qué falta, y la aplicación muestra una
 * pantalla que lo explica (ver PantallaConfiguracion).
 */

type Ambiente = 'local' | 'pruebas' | 'produccion'

function leer(valor: string | undefined): string {
  return (valor ?? '').trim()
}

const supabaseUrl = leer(import.meta.env.VITE_SUPABASE_URL)
const supabaseAnonKey = leer(import.meta.env.VITE_SUPABASE_ANON_KEY)

/** Variables que hacen falta para que el sistema funcione. */
export const variablesFaltantes: string[] = [
  supabaseUrl ? null : 'VITE_SUPABASE_URL',
  supabaseAnonKey ? null : 'VITE_SUPABASE_ANON_KEY',
].filter((nombre): nombre is string => nombre !== null)

export const configuracionCompleta = variablesFaltantes.length === 0

export const entorno = {
  // Valores de reserva para que crear el cliente de Supabase no reviente antes
  // de que la pantalla de configuración alcance a dibujarse. Nunca se usan
  // para una petición real: la aplicación no monta las rutas sin configuración.
  supabaseUrl: supabaseUrl || 'https://configuracion.pendiente.supabase.co',
  supabaseAnonKey: supabaseAnonKey || 'configuracion-pendiente',
  ambiente: (import.meta.env.VITE_AMBIENTE ?? 'local') as Ambiente,
} as const

/**
 * En cualquier ambiente que no sea el productivo, la interfaz muestra un aviso
 * visible. El accidente que esto evita es concreto: cerrar una orden real
 * creyendo que se estaba practicando.
 */
export const esProductivo = entorno.ambiente === 'produccion'

export const etiquetaAmbiente: Record<Ambiente, string> = {
  local: 'Local',
  pruebas: 'Pruebas',
  produccion: 'Producción',
}
